export const typography = {
  Font_Family: {
    $type: "string",
    $value: "Inter",
  },
  Size: {
    Text: {
      xxs: {
        $type: "dimension",
        $value: "10px",
      },
      xs: {
        $type: "dimension",
        $value: "12px",
      },
      sm: {
        $type: "dimension",
        $value: "14px",
      },
      md: {
        $type: "dimension",
        $value: "16px",
      },
      lg: {
        $type: "dimension",
        $value: "18px",
      },
      xl: {
        $type: "dimension",
        $value: "20px",
      },
    },
    Display: {
      xxs: {
        $type: "dimension",
        $value: "22px",
      },
      xs: {
        $type: "dimension",
        $value: "24px",
      },
      sm: {
        $type: "dimension",
        $value: "30px",
      },
      md: {
        $type: "dimension",
        $value: "36px",
      },
      lg: {
        $type: "dimension",
        $value: "48px",
      },
      xl: {
        $type: "dimension",
        $value: "60px",
      },
      "2xl": {
        $type: "dimension",
        $value: "72px",
      },
    },
  },
  Line_height: {
    text: {
      xxs: {
        $type: "dimension",
        $value: "14px",
      },
      xs: {
        $type: "dimension",
        $value: "18px",
      },
      sm: {
        $type: "dimension",
        $value: "20px",
      },
      md: {
        $type: "dimension",
        $value: "24px",
      },
      lg: {
        $type: "dimension",
        $value: "28px",
      },
      xl: {
        $type: "dimension",
        $value: "30px",
      },
    },
    Display: {
      xs: {
        $type: "dimension",
        $value: "32px",
      },
      sm: {
        $type: "dimension",
        $value: "38px",
      },
      md: {
        $type: "dimension",
        $value: "44px",
      },
      lg: {
        $type: "dimension",
        $value: "60px",
      },
      xl: {
        $type: "dimension",
        $value: "72px",
      },
      "2xl": {
        $type: "dimension",
        $value: "90px",
      },
    },
  },
  Font_weight: {
    Regular: {
      $type: "string",
      $value: "Regular",
    },
    Medium: {
      $type: "string",
      $value: "Medium",
    },
    Semibold: {
      $type: "string",
      $value: "600",
    },
    Bold: {
      $type: "string",
      $value: "Bold",
    },
  },

  // text style

  "Display 2xl": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.2xl}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.2xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.2xl}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.2xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.2xl}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.2xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.2xl}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.2xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
  "Display xl": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xl}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xl}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xl}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xl}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
  "Display lg": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.lg}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.lg}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.lg}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.lg}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
  "Display md": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.md}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.md}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.md}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.md}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "-2%",
        lineHeight: "{Line height.Display.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
  "Display sm": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.sm}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.sm}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.sm}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.sm}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Medium italic": {
      $type: "typography",
      $value: {
        fontFamily: "Inter",
        fontSize: "{Size.Display.sm}",
        fontWeight: 500,
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
  "Display xs": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xs}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xs}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xs}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xs}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Medium italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xs}",
        fontWeight: 500,
        letterSpacing: "0%",
        lineHeight: "36px",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Semibold underlined": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Display.xs}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.Display.xs}",
        textTransform: "none",
        textDecoration: "underline",
      },
    },
  },
  "Text xl": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Regular italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: 400,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Medium italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: 500,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Semibold italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: 600,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Bold italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: 700,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Regular underlined": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "underline",
      },
    },
    "Medium underlined": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xl}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xl}",
        textTransform: "none",
        textDecoration: "underline",
      },
    },
  },
  "Text lg": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Regular italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: 400,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Medium italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: 500,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Semibold italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: 600,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Bold italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: 700,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Regular underlined": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "underline",
      },
    },
    "Medium underlined": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.lg}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.lg}",
        textTransform: "none",
        textDecoration: "underline",
      },
    },
  },
  "Text md": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Regular italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: 400,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Medium italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: 500,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Semibold italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: 600,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Bold italic": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: 700,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    "Regular underlined": {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.md}",
        fontWeight: 400,
        letterSpacing: "0%",
        lineHeight: "{Line height.text.md}",
        textTransform: "none",
        textDecoration: "underline",
      },
    },
  },
  "Text sm": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.sm}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.sm}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.sm}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.sm}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.sm}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
  "Text xs": {
    Regular: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xs}",
        fontWeight: "{Font weight.Regular}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Medium: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xs}",
        fontWeight: "{Font weight.Medium}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Semibold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xs}",
        fontWeight: "{Font weight.Semibold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
    Bold: {
      $type: "typography",
      $value: {
        fontFamily: "{Font Family}",
        fontSize: "{Size.Text.xs}",
        fontWeight: "{Font weight.Bold}",
        letterSpacing: "0%",
        lineHeight: "{Line height.text.xs}",
        textTransform: "none",
        textDecoration: "none",
      },
    },
  },
};
